// AGS brand assets
export const AGS_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_industrial-clean-ags/artifacts/9bovgccz_ChatGPT%20Image%20May%2029%2C%202026%2C%2010_19_23%20PM-Photoroom.png";

export const COLORS = {
  navy: "#0E2A57",
  navyHover: "#081A37",
  lightBlue: "#2BB6E5",
  iceBlue: "#BEE7F5",
  ink: "#0A0A0A",
  paper: "#FFFFFF",
  paperAlt: "#F4F8FC",
  border: "#E5EBF2",
};
